/**
 * 결재자 배열 order 오름차순 정렬 — 결재라인 순번 표시의 단일 정렬 기준.
 *
 * v2 응답의 approvers[] 는 order 순 보장이 없다(실측: intranetId 알파벳 순으로 내려옴).
 * 그룹핑·렌더 전에 반드시 이 함수를 거쳐야 순번대로 표시된다.
 * 동일 order(병렬 협조결재)는 Array#sort 안정 정렬로 원본 상대 순서를 유지한다.
 */
const sortApproversByOrder = <T extends { order: number }>(
  approvers: readonly T[],
): T[] => [...approvers].sort((a, b) => a.order - b.order);

export default sortApproversByOrder;
